const aiChat = r => require.ensure([], () => r(require('@/views/aiChat/index.vue'), 'aiChat'))

const router = [
  {
    path: '/aiChat',
    name: 'aiChat',
    meta: {
      title: '智能助手'
    },
    component: aiChat
  }
]

export default router
